import { Stack, Tooltip, Typography } from "@mui/material";

import InfoIcon from "src/assets/svg-icons/info.svg";

interface ITableHeaderCellProps {
  label: string;
  infoText?: string;
}

const TableHeaderCell = ({ label, infoText }: ITableHeaderCellProps) => {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      justifyContent="center"
      alignItems="center"
    >
      <Typography
        fontSize="12px"
        color="#475467"
        lineHeight="18px"
        fontWeight={600}
      >
        {label}
      </Typography>

      {infoText && (
        <Tooltip title={infoText}>
          <img src={InfoIcon} alt="" />
        </Tooltip>
      )}
    </Stack>
  );
};

export default TableHeaderCell;
